import { useEffect, useState } from 'react';

/**
 * 用于避免水合化错误的 Hook
 * 该 Hook 确保某些内容只在客户端渲染
 *
 * @returns boolean - 表示是否在客户端环境
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const isClient = useClientOnly();
 *
 *   if (!isClient) {
 *     return <div>Loading...</div>; // 服务端渲染的回退内容
 *   }
 *
 *   return <ComplexClientComponent />; // 客户端特定的组件
 * }
 * ```
 */
export function useClientOnly(): boolean {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
}

/**
 * 带有延迟的客户端检查，用于需要在水合化后执行的操作
 *
 * @param delay 延迟时间（毫秒），默认为 0
 * @returns boolean - 表示是否在客户端环境且延迟已过
 */
export function useClientOnlyWithDelay(delay = 0): boolean {
  const [isClientReady, setIsClientReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsClientReady(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return isClientReady;
}
